import React from 'react';

import { InfoCardDetailsProps } from './types';
import { ArticleContainer, DateTypography, TitleTypography } from './styles';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import {
  formatDate,
  mapLocaleAccordingToNzRules,
} from '../../../../helpers/localeFormatter';

const NewsDetails: React.FC<InfoCardDetailsProps> = ({
  countryIsoCode,
  selectedArticle,
}) => {
  const { t } = useI18n();
  const mappedCountry = mapLocaleAccordingToNzRules(countryIsoCode);

  if (!selectedArticle) {
    return <p>{t(TranslationKeys.news_preview_no_selected)}</p>;
  }

  const hasDescription = !!selectedArticle.description?.['$cdata_section'];

  return (
    <ArticleContainer>
      {selectedArticle.enclosure && (
        <img
          src={selectedArticle.enclosure['@url']}
          alt={selectedArticle.title}
          className="article-image"
        />
      )}
      <DateTypography>
        {selectedArticle.pubDate
          ? formatDate(selectedArticle.pubDate, mappedCountry)
          : t(TranslationKeys.news_preview_date_not_available)}
      </DateTypography>
      <TitleTypography>{selectedArticle.title}</TitleTypography>
      <div
        className={`article-content ${!hasDescription ? 'without-description' : ''}`}
      >
        {hasDescription && (
          <p className="article-description">
            {selectedArticle.description?.['$cdata_section']}
          </p>
        )}
        <div
          className="article-inner-content"
          dangerouslySetInnerHTML={{
            __html:
              selectedArticle['content$encoded']?.['$cdata_section'] ?? '',
          }}
        />
      </div>
    </ArticleContainer>
  );
};

export default NewsDetails;
